// 获取订单支付信息
import { requestRaw,requestApi,requestApiBody } from '../util/network'

// 用户支付
export const pay =
    (paySn, payType, data, key, uniapp=0) =>
        requestRaw(
            env.SITE_URL + '/index.php?s=api/Memberpayment/' + payType + '/pay_sn/' + paySn + '/password/' + data.password + '/rcb_pay/' + data.rcb_pay + '/pd_pay/' + data.pd_pay + '/payment_code/' + data.payment_code + '/key/' + key + '/uniapp/' + uniapp + '/random_number/' + Math.random() + '/'
        )
// 获取支付方式列表
export const getPaymentList =
    (uniapp=0) =>
        requestApi(
            '/Memberpayment/payment_list',
            'POST',
            {
                payment_platform:uniapp?'app':''
            },
            'member'
        )

// 获取支付方式列表
export const doH5Pay =
    (pay_sn, payment_code, key) =>
	requestRaw(
	    env.SITE_URL + '/index.php?s=api/Memberpayment/pay_new/pay_sn/' + pay_sn + '/payment_code/' + payment_code + '/key/' + key + '/random_number/' + Math.random() + '/'
	)

export const doH5Pay1 =

    (pay_sn, payment_code, key) =>
        requestApiBody(
            `/Memberpayment/vr_pay_new?pay_sn=${pay_sn}&payment_code=${payment_code}&key=${key}`,
            'GET',
			)
    //     requestApiBody(
    //         '/Memberpayment/pay_new',
    //         'POST',
    //         {
    //             pay_sn,
    //             payment_code,
				// key
    //         },
    //         'member'
    //     )
// 获取二维码字符串
// /Memberpayment/pay_new
export const payNew =
    (params) =>
        requestApi(
            '/Memberpayment/pay_new',
            'POST',
            {
                ...params
            },
            'member'
        )
// 获取图片
export const getQrcode =
    (data) =>
    requestRaw(
	    env.SITE_URL + '/home/Payment/qrcode?data=' + data
	)
    // requestApi(
    //         '/home/Payment/qrcode',
    //         'GET',
    //         {
    //             data:data
    //         },
    //         'member'
    //     )
// 获取支付方式列表
export const getOrderState =
    (pay_sn) =>
        requestApiBody(
            '/Index/getNewOrderState',
            'GET',
            {
                pay_sn:pay_sn
            },
            'member'
        )
// 得到订单状态
// getOrderState